import React from "react";

function AnimatedText({ text, delay = 150, className = "" }) {
  const words = text.split(" ");

  return (
    <p className={className}>
      {words.map((word, i) => (
        <span
          key={i}
          className="word-animate"
          style={{ animationDelay: `${i * delay}ms` }}
        >
          {word}&nbsp;
        </span>
      ))}
    </p>
  );
}

export default AnimatedText;
